<form class="form-auth">
	<div class="container-fluid d-flex w-100 justify-content-center" id="main">
		<div class="bg-white rounded p-3 col-md-8 col-md-offset-1" id="left">
			<h2 class="text-center">{{'multi_force_read_debug.title' | translate}}</h2>

			<div class="row col-md-12 p-3 mt-3">
				<div class="col-md-5">
					<span class="mr-1">*</span>
					<strong>{{'multi_force_read_debug.mac_addresses' | translate}}</strong>
				</div>
				<div class="col-md-7">
					<textarea
						class="form-control mac-addresses-textarea"
						name="macAddressesInput"
						[(ngModel)]="macAddressesInput"
						[ngClass]="{'invalid-input': invalidMacAddresses.length}"
						placeholder="{{'multi_force_read_debug.mac_addresses_placeholder' | translate}}"
					></textarea>
				</div>
			</div>

			<div class="row col-md-12 px-3" *ngIf="invalidMacAddresses.length">
				<div class="col-md-5"></div>
				<div class="col-md-7">
					<div class="alert alert-danger mb-0">
						<strong>{{'multi_force_read_debug.invalid_mac_addresses' | translate}}:</strong>
						<ul class="mb-0 mt-2">
							<li *ngFor="let macAddress of invalidMacAddresses">{{macAddress}}</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="row col-md-12 p-3">
				<div class="col-md-5">
					<span class="mr-1">*</span>
					<strong>{{'force_read_debug.sub_title' | translate}}</strong>
				</div>
				<div class="col-md-7">
					<input
						class="form-control"
						type="number"
						name="force_read_debug_time"
						[min]="minAllowedDebugHours"
						[max]="maxAllowedDebugHours"
						[(ngModel)]="force_read_debug_time"
					/>
				</div>
			</div>

			<div class="form-buttons d-flex justify-content-end">
				<button class="btn btn-primary mb20" type="button" [disabled]="isSubmitting || force_read_debug_time == null" (click)="saveDebugDate()">
					{{'g.submit' | translate}}
				</button>
				
				<button
					class="btn btn-success ml-4" type="button" [disabled]="isSubmitting" (click)="saveDebugDate(true)">
					{{'force_read_debug.force_read_debug_now' | translate}}
				</button>
			</div>

			<div class="result-box mt-4" *ngIf="result">
				<h4>{{'multi_force_read_debug.result_summary' | translate}}</h4>
				<div class="row mt-3">
					<div class="col-md-4">
						<strong>{{'multi_force_read_debug.total_devices' | translate}}:</strong> {{result.total}}
					</div>
					<div class="col-md-4">
						<strong>{{'multi_force_read_debug.successful' | translate}}:</strong> {{result.success}}
					</div>
					<div class="col-md-4">
						<strong>{{'multi_force_read_debug.failed' | translate}}:</strong> {{result.failed}}
					</div>
				</div>

				<div class="mt-4" *ngIf="result.failed_devices && result.failed_devices.length">
					<h5>{{'multi_force_read_debug.failed_devices' | translate}}</h5>
					<table class="table table-striped table-bordered mt-2">
						<thead>
							<tr>
								<th>{{'multi_force_read_debug.mac_address' | translate}}</th>
								<th>{{'multi_force_read_debug.failure_reason' | translate}}</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let failedDevice of result.failed_devices">
								<td>{{failedDevice.mac_address}}</td>
								<td>{{failedDevice.reason}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</form>
